import React, {useContext, useEffect, useState} from "react";
import {TranslateContext} from "../../../context/TranslateContext";
import {useHistory} from "react-router-dom";
import {MobileContext} from "../../../context/MobileContext";
import {
    deleteTipoImpExpDatiByIdApi,
    getStrutturaTipiImpExpDatiApi,
    getTipiImpExpDatiApi
} from "../services/TipiImpExpDatiServices";
import ConfTipoImpExpDatiView from "./ConfTipoImpExpDatiView";
import AlberoStrutturaTipiImpExpController from "./AlberoStrutturaTipiImpExpController";

export default function ConfTipoImpExpDatiController() {

    const [loadingData, setLoadingData] = useState(true);
    const [tipiImpExp, setTipiImpExp] = useState([]);
    const [show, setShow] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [modalMsg, setModalMsg] = useState('');
    const [treeData, setTreeData] = useState([]);
    const [tipoSel, setTipoSel] = useState();

    const {isMobile} = useContext(MobileContext);
    const {translate} = useContext(TranslateContext);

    const history = useHistory();

    async function getTipiImpExp() {
        const response = await getTipiImpExpDatiApi();
        setTipiImpExp(response.data.data);
        setLoadingData(false);
    }

    async function getStruttura() {
        let idSelezionato = tipoSel ? tipoSel.id : 0;
        const response = await getStrutturaTipiImpExpDatiApi(idSelezionato)
        setTreeData(response.data.data?.struttura);
    }

    useEffect(() => {
        getTipiImpExp();

        if (loadingData) {
            getStruttura();
        }
    }, [tipoSel, loadingData]);

    const eliminaElemento = async () => {
        setShowConfirm(false);
        const response = await deleteTipoImpExpDatiByIdApi(tipoSel.id);
        if (response.data.result === -1) {
            setModalMsg(response.data.description)
            setShow(true)
        } else {
            setTipiImpExp(response.data.data);
            getStruttura();
        }
    }

    function getAlberoStruttura() {
        return <AlberoStrutturaTipiImpExpController
            setShowConfirm={setShowConfirm}
            history={history}
            translate={translate}
            tipoSel={tipoSel}
            setTipoSel={setTipoSel}
            treeData={treeData}
        />;
    }

    return (
        <ConfTipoImpExpDatiView
            showConfirm={showConfirm}
            modalMsg={modalMsg}
            show={show}
            loadingData={loadingData}
            setShowConfirm={setShowConfirm}
            isMobile={isMobile}
            setShow={setShow}
            translate={translate}
            tipoSel={tipoSel}
            getAlberoStruttura={getAlberoStruttura}
            eliminaElemento={eliminaElemento}
            tipiImpExp={tipiImpExp}
        />
    );
}
